module.exports = __webpack_public_path__ + "static/media/massage-3607837_1280.e5998f43.jpg";